import angular from "angular";

angular
    .module('app')
    .component('taskForm', {
        template: require('./task-form.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', '$scope', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, ErrorResponseParser, Notifier, $scope) {

    let $ctrl = this;


    $ctrl.id = null;
    $ctrl.title = null;
    $ctrl.description = null;
    $ctrl.type = null;

    $ctrl.$onInit = function () {
        $ctrl.task = $ctrl.resolve.task;
        $ctrl.lesson = $ctrl.resolve.lesson;
        $ctrl.course = $ctrl.resolve.course;

        if ($ctrl.task) {
            $ctrl.id = $ctrl.task.id;
            $ctrl.title =  $ctrl.task.title;
            $ctrl.description =  $ctrl.task.description;
            $ctrl.type =  $ctrl.task.type;
        }
    };


    $ctrl.submit = function () {

        let req = null;
        let params = {
            title: $ctrl.title,
            lesson_id: $ctrl.lesson.id,
            description: $ctrl.description,
            type: $ctrl.type
        };

        $ctrl.loading = true;

        if ($ctrl.id) {
            params['_method'] = 'PUT';
            req = $http.post(`/admin/courses/${$ctrl.course.id}/lessons/${$ctrl.lesson.id}/tasks/${$ctrl.task.id}`, params);
        } else {
            req = $http.post(`/admin/courses/${$ctrl.course.id}/lessons/${$ctrl.lesson.id}/tasks`, params);
        }


        req.then(
            function (response) {
                if (!$ctrl.id) {
                    $ctrl.id = response.data.task_id;
                    $ctrl.loading = false;
                    Notifier.success('Задача добавлена', 2);
                } else {

                    $ctrl.loading = false;
                    Notifier.success('Задача обновлена', 2);
                }
                $ctrl.close({
                    $value: {
                        id: $ctrl.id,
                        title: $ctrl.title,
                        description: $ctrl.description,
                        type: $ctrl.type
                    }
                });
            },
            function (error) {
                ErrorResponseParser.parse(error);
            }
        );
    }

}